import {mapGetters} from 'vuex';

export default {
    name: 'mvtCardPoi',
    inject: ['$eventBus'],
    props: {
        data: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            default: {}
        }
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        directionUrl(){
            var directionUrl='';
            if(this.data.latitude  && this.data.longitude){
                directionUrl +=  ('saddr=' + this.data.latitude + ',' + this.data.longitude);
            }
            if(this.options.center && this.options.center.latitude &&  this.options.center.longitude){
                directionUrl +=  ('&daddr='+ this.options.center.latitude+','+this.options.center.longitude);
            }
            if(this.data.lat && this.data.lon){
                directionUrl += ('saddr=' + this.data.lat + ',' + this.data.lon);
            }
            if(directionUrl){
                return 'http://maps.apple.com/?' + directionUrl
            }else{
                return ''
            }
        }
    }
}
